
<template>
    <div class="section-block vacancies-block">
        <div class="container ">
            <div class="card">
                <h2 class="display-5 mb-4" >
                    Ik zoek werk
                </h2>
                <p>Bekijk de volgende vacatures:</p>
                <ul>
                    <li v-for="page in orderedPages">
                        <a class="" :href="page.pageslug">
                                    {{ page.pagetitle }} 
                        </a>
                    </li>
                </ul>
            </div>
            <div class="card">
                <h2 class="display-5 mb-4" >
                    Ik zoek personeel
                </h2>
                <p>Bel of mail ons</p>
            </div>
        </div>
    </div>
</template>

<script>

import { userService } from '../../services/user.service.js';
import { authHeader } from '../../services/auth-header.js';

import axios from 'axios';

export default {
    props: {
        pageid: String,
        websiteid: String,
        readonly: Boolean
    },
    computed: {
      orderedPages: function () {
        return _.orderBy(this.pages, 'order', 'desc')
      }
    },
    data: function() {
        return{
            readonly: false,
            showModal: false,
            pages: {}
        }
    },
    methods: {
        getPages(){
            axios.get(process.env.VUE_APP_ROOT_API+'/pages/'+this.websiteid+'/blockstyle/Vacancies-item')
            .then(response => {
              console.log('pages loaded')
                this.pages = response.data.response
            })
        },
        removePage(id){
            axios.delete(process.env.VUE_APP_ROOT_API+'/pages/'+this.websiteid+'/'+id)
            .then(response => {
                console.log(response)
                this.showModal = false
            })
        }
    },
    mounted(){
        this.getPages()
    }
}
</script>